module.exports = __webpack_public_path__ + "img/user_cancel_success.37dae5a8.png";